import { render, staticRenderFns } from "./HeaderToolbar.vue?vue&type=template&id=2aedd283"
import script from "./HeaderToolbar.vue?vue&type=script&lang=js"
export * from "./HeaderToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports